// DS: i4.10
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Check = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.42651 15.5356C6.9741 15.2188 6.86416 14.5953 7.18093 14.1429C7.49771 13.6905 8.12126 13.5805 8.57366 13.8973L11.0303 15.6175L16.7669 7.42651C17.0837 6.9741 17.7072 6.86416 18.1596 7.18093C18.612 7.49771 18.722 8.12126 18.4052 8.57366L12.0958 17.5843C11.8017 18.0044 11.243 18.1292 10.8025 17.8913L10.7031 17.8299L7.42651 15.5356Z"
    })));
};
Check.displayName = 'Check';
export default Check;
